import {Component, Input} from '@angular/core';
import {TileType23_24} from "../../../models";
import {
    IconService,
    ParametersService,
    SubtitlesService, TilesService,
} from "../../../core";


@Component({
    selector: 'tile-built-in-valve',
    templateUrl: './tile-built-in-valve.component.html',
    styleUrls: ['./tile-built-in-valve.component.scss']
})
export class TileBuiltInValveComponent {
    @Input() tile: TileType23_24;

    constructor(
        public icon: IconService,
        private parameters: ParametersService,
        public subtitles: SubtitlesService,
        private tiles: TilesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    openSubmenu() {
        this.tiles.openSubmenu(this.tile.elementMenu);
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }

    getSetTemp() {
        return this.tile.params.setTemp + this.tile.params.setTempCorrection;
    }
}
